import { Field } from 'redux-form';

import { SelectField } from 'common/components/forms';

const CreditCardPicker = (props) => {
  const { customerCreditCards, onCreditCardChange } = props;
  if (!customerCreditCards) {
    return null;
  }
  const creditCardArrayIds = Object.keys(customerCreditCards);
  const customerCreditCardArray = creditCardArrayIds.map(
    (creditCardId) => customerCreditCards[creditCardId]
  );
  if (customerCreditCardArray.length > 0) {
    return (
      <Field
        name="customerCreditCardId"
        component={SelectField}
        optionArray={creditCardOptionArray(customerCreditCardArray)}
        label="Credit Card"
        onChange={onCreditCardChange}
      />
    );
  }
  return null;
};

export default CreditCardPicker;

const creditCardOptionArray = (creditCards) => {
  const array = [];
  array.push({ option: 'New Credit Card', value: '' });
  creditCards.forEach((creditCard) => {
    array.push({ option: creditCardOneLine(creditCard), value: creditCard.id });
  });
  return array;
};

const creditCardOneLine = (card) =>
  `${card.maskedCardNumber} Exp: ${card.expiryMo}/${card.expiryYr}`;
